import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Alert } from "../typeDefs/configuration";

export interface ConfigState {
    flags: any;
    pythonIntegrations: string[];
    alerts: Alert[];
    alertsLoading: boolean;
}

const initialState: ConfigState = {
    flags: {},
    pythonIntegrations: [],
    alerts: [],
    alertsLoading: false,
};

export const configSlice = createSlice({
    name: "config",
    initialState,
    reducers: {
        setPortalDisplayFlags: (state, action: PayloadAction<object>) => {
            state.flags = action.payload;
        },
        setPythonIntegrations: (state, action: PayloadAction<string[]>) => {
            state.pythonIntegrations = action.payload;
        },
        setAlerts: (state, action: PayloadAction<Alert[]>) => {
            state.alerts = action.payload;
        },
        setAlertsLoading: (state, action: PayloadAction<boolean>) => {
            state.alertsLoading = action.payload;
        },
    },
});

export const {
    setPortalDisplayFlags,
    setPythonIntegrations,
    setAlerts,
    setAlertsLoading,
} = configSlice.actions;

export default configSlice.reducer;
